import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store';
import api from '../services/api';

const PAGE_BG = 'radial-gradient(900px 480px at 75% -10%, rgba(75,223,142,.14), transparent 60%), #080c0a';
const CARD = {
  background: '#0e1311', border: '1px solid #1e2a24', borderRadius: 18,
  boxShadow: '0 20px 60px rgba(0,0,0,.5)',
};
const EMERALD = '#4bdf8e';

function Brand() {
  return (
    <div style={{ textAlign: 'center', marginBottom: 26 }}>
      <div style={{
        width: 44, height: 44, borderRadius: 12, border: `2px solid ${EMERALD}`,
        display: 'grid', placeItems: 'center', transform: 'rotate(-8deg)',
        fontFamily: 'Outfit', fontSize: 24, fontWeight: 800, color: '#fff',
        margin: '0 auto 14px',
      }}>G</div>
      <div style={{ fontFamily: 'Outfit', fontSize: 24, fontWeight: 800, color: '#fff' }}>
        Guara<span style={{ color: EMERALD }}>po</span>
      </div>
      <div style={{ fontSize: 12.5, color: '#8fa399', marginTop: 4 }}>Entrega de efectivo en Cuba</div>
    </div>
  );
}

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [twoFARequired, setTwoFARequired] = useState(false);
  const [tempToken, setTempToken] = useState('');
  const [twoFAMethod, setTwoFAMethod] = useState('');
  const [twoFACode, setTwoFACode] = useState('');
  const { login } = useAuthStore();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const result = await login(email, password);
      if (result.requires2FA) {
        setTempToken(result.tempToken);
        setTwoFAMethod(result.method);
        setTwoFARequired(true);
        setError('');
      } else {
        navigate(result.role === 'admin' ? '/admin' : '/dashboard');
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Credenciales incorrectas');
    } finally {
      setLoading(false);
    }
  };

  const handle2FA = async () => {
    if (!twoFACode || twoFACode.length < 6) return;
    setLoading(true); setError('');
    try {
      const res = await api.post(`/api/v1/2fa/verify?temp_token=${tempToken}&code=${twoFACode}`);
      const { access_token, role } = res.data;
      localStorage.setItem('token', access_token);
      useAuthStore.setState({ token: access_token, role, user: { email, role } });
      navigate(role === 'admin' ? '/admin' : '/dashboard');
    } catch (e) {
      setError(e.response?.data?.detail || 'Código 2FA incorrecto');
    } finally { setLoading(false); }
  };

  const errBox = error && (
    <div style={{ background: 'rgba(220,76,100,.12)', borderRadius: 8, padding: '9px 14px', marginBottom: 14, fontSize: 13, color: '#ff8aa0' }}>
      ⚠ {error}
    </div>
  );

  if (twoFARequired) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: PAGE_BG, padding: 20 }}>
      <div style={{ ...CARD, padding: 36, width: 'min(400px, 92vw)' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 44, marginBottom: 12 }}>🔐</div>
          <h2 style={{ fontFamily: 'Outfit', fontSize: 24, margin: '0 0 8px', color: '#f7faf8' }}>Verificación 2FA</h2>
          <p style={{ fontSize: 13, color: '#8fa399', margin: 0 }}>
            {twoFAMethod === 'totp' ? 'Introduce el código de tu app autenticadora' :
             twoFAMethod === 'email' ? 'Introduce el código enviado a tu email' :
             'Introduce el código enviado por SMS'}
          </p>
        </div>
        {errBox}
        <input
          style={{
            width: '100%', padding: '14px', border: '2px solid #243029', borderRadius: 10,
            fontSize: 28, fontWeight: 700, textAlign: 'center', letterSpacing: 8,
            outline: 'none', boxSizing: 'border-box', fontFamily: 'monospace', marginBottom: 16,
            background: '#0a0f0c', color: '#f7faf8',
          }}
          placeholder="000000" maxLength={6}
          value={twoFACode}
          onChange={e => setTwoFACode(e.target.value.replace(/\D/g, ''))}
          autoFocus
        />
        {twoFAMethod !== 'totp' && (
          <button onClick={() => api.post(`/api/v1/2fa/send-otp?temp_token=${tempToken}`)}
            style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #243029', background: 'transparent', fontSize: 13, cursor: 'pointer', marginBottom: 10, color: '#8fa399' }}>
            Reenviar código
          </button>
        )}
        <button onClick={handle2FA} disabled={loading || twoFACode.length < 6}
          style={{
            width: '100%', padding: '13px', borderRadius: 10, border: 'none',
            background: (loading || twoFACode.length < 6) ? '#1b231f' : EMERALD,
            color: (loading || twoFACode.length < 6) ? '#5c6b63' : '#06281a',
            fontSize: 15, fontWeight: 800,
            cursor: (loading || twoFACode.length < 6) ? 'not-allowed' : 'pointer',
          }}>
          {loading ? 'Verificando...' : 'Verificar →'}
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: PAGE_BG, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ ...CARD, width: 400, maxWidth: '95vw', padding: '36px 32px' }}>
        <Brand />
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 14 }}>
            <label style={lbl}>Email</label>
            <input style={inp} type="email" placeholder="tu@email.com"
              value={email} onChange={e => setEmail(e.target.value)} required />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={lbl}>Contraseña</label>
            <input style={inp} type="password" placeholder="••••••••"
              value={password} onChange={e => setPassword(e.target.value)} required />
          </div>
          {errBox}
          <button type="submit" disabled={loading} style={{
            width: '100%', padding: '12px', borderRadius: 10, border: 'none',
            background: EMERALD, color: '#06281a', fontSize: 14, fontWeight: 800,
            cursor: 'pointer', opacity: loading ? .7 : 1,
          }}>{loading ? 'Entrando...' : 'Entrar →'}</button>
        </form>
        <div style={{ textAlign: 'center', marginTop: 16, fontSize: 12.5, color: '#8fa399' }}>
          ¿No tienes cuenta? <a href="/registro" style={{ color: EMERALD, fontWeight: 700, textDecoration: 'none' }}>Regístrate</a>
        </div>
      </div>
    </div>
  );
}

const lbl = { display: 'block', fontSize: 10.5, fontWeight: 700, letterSpacing: '.07em', textTransform: 'uppercase', color: '#8fa399', marginBottom: 6 };
const inp = { width: '100%', padding: '11px 14px', border: '1px solid #243029', borderRadius: 10, fontSize: 14, outline: 'none', boxSizing: 'border-box', background: '#0a0f0c', color: '#f7faf8' };
